import classNames from 'classnames';

import CardIcon from '../CardIcon/CardIcon';

import { cardTypeOfCreditCardBrand, CreditCardBrand } from '@types-internal';

import styles from './SupportedCardList.module.scss';

interface SupportedCardListProps {
  /* The list of card brands to be presented. */
  cardBrands: CreditCardBrand[];
  size?: 's' | 'l';
}

/**
 * Render a list of card icons. Main usage at the moment is to be displayed above the credit card form.
 */
const SupportedCardList = ({ cardBrands, size }: SupportedCardListProps) => {
  return (
    <div
      data-zta="supported-card-list"
      className={classNames(styles.cardsContainer, {
        [styles.smallCardsContainer]: size === 's',
      })}>
      {cardBrands.map((cardBrand) => (
        <CardIcon
          className={classNames({ [styles.cardIconSmall]: size === 's' })}
          key={cardBrand}
          type={cardTypeOfCreditCardBrand[cardBrand]}
        />
      ))}
    </div>
  );
};

export default SupportedCardList;
